import querystring from "querystring"
import {isNil, omitBy} from "lodash"


export default (location) => {
  const {search} = location
  const filters = querystring.parse(search.replace("?", ""))
  return omitBy(filters, isNil)
}
